<!--
    CrEiCandidateRendererComponent Template
    Custom renderer for CR Customer candidates in EI Scoped Lookup.
    Displays customer-specific fields: name, number, category, assignment type.
-->
@if (candidate) {
    <div class="flex align-items-center justify-content-between p-3 border-1 surface-border border-round mb-2 surface-card hover:surface-hover transition-duration-150">
        <div class="flex-1">
            <!-- Row 1: Customer Icon + Name + Customer Number + Similarity -->
            <div class="flex align-items-center gap-2 mb-1">
                <i class="fa-regular fa-address-card text-primary"></i>
                <span class="font-semibold cursor-pointer text-primary hover:underline"
                      (click)="navigateToCustomer()">
                    {{ customerName }}
                </span>
                @if (customerNumber) {
                    <span class="text-xs text-color-secondary">#{{ customerNumber }}</span>
                }
                @if (candidate.similarity != null) {
                    <p-tag [value]="(candidate.similarity * 100 | number:'1.0-0') + '% Match'"
                           [severity]="getSimilaritySeverity(candidate.similarity)"
                           [rounded]="true"
                           styleClass="text-xs ml-auto"></p-tag>
                }
            </div>

            <!-- Row 2: Category + Assignment Type -->
            <div class="flex align-items-center gap-2 flex-wrap mt-1">
                @if (customerCategory) {
                    <p-tag [value]="customerCategory"
                           severity="info"
                           [rounded]="true"
                           styleClass="text-xs"></p-tag>
                }
                @if (assignmentType) {
                    <p-tag [value]="assignmentType"
                           severity="secondary"
                           [rounded]="true"
                           styleClass="text-xs"></p-tag>
                }
            </div>
        </div>

        <!-- Assign Button -->
        <div class="ml-3">
            <p-button icon="fa-regular fa-check"
                      [rounded]="true"
                      [text]="true"
                      severity="success"
                      (onClick)="assignCandidate()"
                      pTooltip="Zuweisen"
                      tooltipPosition="left"></p-button>
        </div>
    </div>
}
